
      import * as GOVUK from 'govuk-frontend/dist/govuk/govuk-frontend.min.js'
      import * as LBCamden from './all.js';

      (function initLibs () {
        const init = (opts) => {
          GOVUK.initAll(opts);
          LBCamden.initAll(opts);
        }

        const tryInit = () => {
          if (document.readyState === 'complete') {
            init()
            return true
          }
        }

        Object.assign(window, {
          LBCamden: {
            reinitialize: init
          }
        })

        tryInit()
        document.addEventListener('readystatechange', tryInit)
      })()
    